import {useMediaUrl, usePerson, useUpdatePerson, useUploadMedia, usePrompt, useAddImgDesc, useDeleteMedia, useDeleteImgDesc, useImgDesc, useUpdateImgDesc} from '../hooks/hooks_index';
import { useAuthUser, Loading, MediaImage, getLocalDateString, getLocalDateStringISO } from "../components/components_index";
import { Link, useParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useState, useRef, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import '../styles/Profile.css'

export default function Profile() {
  const {loginID:meID} = useAuthUser();
  const {profileID} = useParams();
  const loginID = profileID || meID;
  const { logout } = useAuth0();
  const {data: person, isLoading: personLoading, error: personError} = usePerson(loginID);
  const [editImg, setEditImg] = useState(false);
  const [editingPic, setEditingPic] = useState(null);
  const [isCopied, setIsCopied] = useState(false);

  if (personLoading) return "";
  if (personError) return "";
  if (!person) return "";

  // function clickCopy () {
  //   navigator.clipboard.writeText('spradleyhistorian@gmail.com')
  //   setIsCopied(true)
  //   setTimeout(() => {
  //     setIsCopied(false)
  //   }, 2500)
  // } 
  async function clickCopy() {
    const email = 'spradleyhistorian@gmail.com';

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(email);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = email;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }

      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 2500);

    } catch (error) {
      console.error('Failed to copy email:', error);
    }
  }

  return (
    <div className='profile-page'>
      <div className="page-title">{loginID === meID ? 'Your' : `${person.AKA?.split(' ')[0]??`${person.f_name}`}'s`} Profile</div>
      <div className='profile-intro-box'>
        <div className='profile-intro-img'>
          <MediaImage mediaID={person.profile_pic ?? "S_logo_PNG.png"}/>
          <button className='edit-pic-button' onClick={(e) => {
            e.stopPropagation();
            setEditingPic(person.profile_pic);
            setEditImg(true);
            }}
          >
            Change Profile Pic
          </button>
        </div>
        <div className='profile-intro-text'>Hi {person.AKA?.split(' ')[0]??`${person.f_name}`}!</div>
      </div>
      <div className='profile-options'>
        <Link to={`/people/${loginID}`}>Your Bio</Link>
        <Link to={'/edit-bio'}>Edit Your Bio Page</Link>
        <Link to={'/uploaded-photos'}>View Your Images</Link>
        <Link to={`/edit-img`}>Add Images</Link>
      </div>
      <div className='log-out'>
        <button
          className='log-out-button'
          onClick={() =>
            logout({
              logoutParams: {
                returnTo: window.location.origin
              }
            })
          }
        >
          Log Out
        </button>
      </div>
      <div className='additional-info'> 
        For any changes or updates to your info, edits to pictures uploaded by others, or to give suggestions for new features, email{' '} 
        <button 
          type="button" 
          onClick={clickCopy} 
          className="email-copy-button"
          title='Copy email to clipboard'> 
            spradleyhistorian@gmail.com
        </button> 
      </div>
      {isCopied &&
        <div className='additional-info copied-box'> 
        Email copied to clipboard!
        </div>
      }
      {editImg &&
        <EditImgPopup 
          // currentPic={person.profile_pic}  
          currentPic={editingPic}
          onClose={() => setEditImg(false)}
          loginID={loginID}
          person={person}
        />
      }
    </div>
  )
}

function EditImgPopup({currentPic, onClose, loginID, person}) {
  const queryClient = useQueryClient();
  const oldPic = currentPic
  const displayPic = oldPic ?? "S_logo_PNG.png";
  const popupRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const uploadMedia = useUploadMedia();
  const deleteMedia = useDeleteMedia();
  const updatePerson = useUpdatePerson();
  const updateImgDesc = useUpdateImgDesc();
  const addImgDesc = useAddImgDesc();
  const deleteImgDesc = useDeleteImgDesc();

  const {data: oldDesc, isLoading: loading, error} = useImgDesc(displayPic); 

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    console.log("EditImgPopup mounted");
    return () => console.log("EditImgPopup unmounted");
  }, []);

  if (loading) return "";
  if (error) return "";

  return (
    <div
      className='profile-pic-popup'
      onClick={(isEditing||isUploading)?undefined:onClose}
      ref={popupRef}
    >
      <div className='profile-pic-popup-box' onClick={e => e.stopPropagation()}>
        <button className='close-profile-pic-popup' onClick={isEditing?undefined:onClose} disabled={isEditing}>{'\u00D7'}</button>
        {!isEditing && !isUploading &&
          <div>
            {displayPic &&
              <MediaImage mediaID={displayPic} className='profile-pic-img' />
            }
            <div className='profile-pic-options'>
              <button onClick={() => setIsEditing(true)} disabled={!currentPic}>Resize Image</button>
              <button onClick={() => setIsUploading(true)}>Upload New Image</button>
            </div>
          </div>
        }
        {isEditing &&
          <ResizeProfilePic
            imageSrc={oldPic}
            onCancel={() => setIsEditing(false)}
            onSave={async (blob) => {
              const file = new File([blob], `profile-${Date.now()}.png`, {type:"image/png"});

              const res = await uploadMedia.mutateAsync(file);

              await updatePerson.mutateAsync({
                id: loginID,
                data: {
                  ...person,
                  profile_pic: res.media_id
                },
              });

              const newData = {
                ...oldDesc,
                cropped: "cropped"
              }

              console.log(oldPic)
              await addImgDesc.mutateAsync({
                id: res.media_id,
                data: newData
              })

              if (oldDesc["cropped"]) {
                await deleteMedia.mutateAsync(oldPic)
              } else {
                const {profilePic, ...changedData} = oldDesc;
                await updateImgDesc.mutateAsync({
                  id:oldPic,
                  data:changedData
                }); 
              }
              if (oldPic && oldDesc["cropped"]) {
                await deleteImgDesc.mutateAsync(oldPic);
              }

              // queryClient.invalidateQueries({queryKey: ['people', loginID]})
              queryClient.setQueryData(["people", loginID], (old) => ({
                ...old,
                profile_pic: res.media_id,
              }));
              setIsEditing(false);
              onClose();
            }}
          />
        }
        {isUploading &&
          <UploadProfilePic setIsUploading={setIsUploading} loginID={loginID} person={person} currentPic={currentPic} onClose={onClose}/>
        }
      </div>
    </div>
  )
}

function ResizeProfilePic({ imageSrc, onSave, onCancel }) {
  const isBlob = imageSrc.startsWith("blob:");
  const { data: url } = useMediaUrl(imageSrc, {
    enabled: !isBlob,
  });

  const cropUrl = isBlob
    ? imageSrc
    : url
      ? `${url}&crop=1`
      : null;

  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);


  const drag = useRef(false);
  const startDrag = useRef({
    x: 0,
    y: 0,
  });

  const pointers = useRef(new Map());
  const pinchStart = useRef(null);

  const [imgPosition, setImgPosition] = useState({
    x: 0,
    y: 0,
  });

  const [imgZoom, setImgZoom] = useState(1);
  const [baseSize, setBaseSize] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  function getPointerCenter() {
    const pts = [...pointers.current.values()];

    if (pts.length < 2) {
      return null;
    }

    return {
      x: (pts[0].x + pts[1].x) / 2,
      y: (pts[0].y + pts[1].y) / 2,
    };
  }

  function getPointerDistance() {
    const pts = [...pointers.current.values()];

    if (pts.length < 2) {
      return 0;
    }

    return Math.hypot(
      pts[0].x - pts[1].x,
      pts[0].y - pts[1].y
    );
  }

  function clampPosition(posX, posY, zoom = imgZoom) {
    if (!baseSize || !containerRef.current) {
      return {
        x: posX,
        y: posY,
      };
    }

    const container =
      containerRef.current.getBoundingClientRect();

    const scaledWidth = baseSize.width * zoom;
    const scaledHeight = baseSize.height * zoom;

    const extraX =
      (scaledWidth - baseSize.width) / 2;

    const extraY =
      (scaledHeight - baseSize.height) / 2;

    const minX =
      container.width -
      baseSize.width -
      extraX;

    const maxX = extraX;

    const minY =
      container.height -
      baseSize.height -
      extraY;

    const maxY = extraY;

    return {
      x: Math.max(minX, Math.min(posX, maxX)),
      y: Math.max(minY, Math.min(posY, maxY)),
    };
  }
  

  function onPointerDown(e) {
    e.preventDefault();

    const element = e.currentTarget;

    // Track this pointer.
    pointers.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY,
    });

    element.setPointerCapture(e.pointerId);

    if (pointers.current.size === 1) {
      drag.current = true;

      startDrag.current = {
        x: e.clientX - imgPosition.x,
        y: e.clientY - imgPosition.y,
      };

      return;
    }

    if (
      pointers.current.size === 2 &&
      baseSize &&
      containerRef.current
    ) {
      drag.current = false;

      pinchStart.current = {
        distance: getPointerDistance(),
        zoom: imgZoom,
        center: getPointerCenter(),
        position: {
          x: imgPosition.x,
          y: imgPosition.y,
        },
      };
    }
  }

  function onPointerMove(e) {
    if (!pointers.current.has(e.pointerId)) return;

    pointers.current.set(e.pointerId, {
      x: e.clientX,
      y: e.clientY,
    });

    if (
      pointers.current.size === 2 &&
      pinchStart.current &&
      baseSize &&
      containerRef.current
    ) {
      const currentDistance = getPointerDistance();
      const currentCenter = getPointerCenter();

      if (!currentCenter) return;

      const {
        distance: startDistance,
        zoom: startZoom,
        center: startCenter,
        position: startPosition,
      } = pinchStart.current;

      const container = containerRef.current.getBoundingClientRect();

      const minZoom = Math.max(
        container.width / baseSize.width,
        container.height / baseSize.height
      );

      const newZoom = Math.min(
        4,
        Math.max(
          minZoom,
          startZoom * (currentDistance / startDistance)
        )
      );

      const zoomRatio = newZoom / startZoom;

      const pinchStartX =
        startCenter.x - container.left;

      const pinchStartY =
        startCenter.y - container.top;

      const pinchCurrentX =
        currentCenter.x - container.left;

      const pinchCurrentY =
        currentCenter.y - container.top;

      const movementX =
        pinchCurrentX - pinchStartX;

      const movementY =
        pinchCurrentY - pinchStartY;

      const nextX =
        startPosition.x +
        movementX -
        (pinchStartX - container.width / 2) *
          (zoomRatio - 1);

      const nextY =
        startPosition.y +
        movementY -
        (pinchStartY - container.height / 2) *
          (zoomRatio - 1);

      setImgZoom(newZoom);

      setImgPosition(
        clampPosition(
          nextX,
          nextY,
          newZoom
        )
      );

      return;
    }
      
    if (
      pointers.current.size === 1 &&
      drag.current
    ) {
      const newX =
        e.clientX - startDrag.current.x;

      const newY =
        e.clientY - startDrag.current.y;

      setImgPosition(
        clampPosition(newX, newY, imgZoom)
      );
    }
  }

  function onPointerUp(e) {
    pointers.current.delete(e.pointerId);

    try {
      e.currentTarget.releasePointerCapture(
        e.pointerId
      );
    } catch {
      // Pointer capture may already have been released.
    }

    if (pointers.current.size === 0) {
      drag.current = false;
      pinchStart.current = null;
      return;
    }

    if (pointers.current.size === 1) {
      drag.current = false;
      pinchStart.current = null;
    }
  }

  function onPointerCancel(e) {
    pointers.current.delete(e.pointerId);

    if (pointers.current.size === 0) {
      drag.current = false;
      pinchStart.current = null;
    }
  }

  useEffect(() => {
    const el = containerRef.current;

    if (!el) {
      return;
    }

    function handleWheel(e) {
      e.preventDefault();

      if (!baseSize || !imgRef.current) {
        return;
      }

      const rect =
        el.getBoundingClientRect();

      const mouseX =
        e.clientX - rect.left;

      const mouseY =
        e.clientY - rect.top;

      const img =
        imgRef.current;

      const imgWidth =
        img.offsetWidth;

      const imgHeight =
        img.offsetHeight;

      setImgZoom((prevZoom) => {
        const minZoom = Math.max(
          rect.width / baseSize.width,
          rect.height / baseSize.height
        );

        const newZoom = Math.min(
          4,
          Math.max(
            minZoom,
            prevZoom -
              e.deltaY * 0.00035
          )
        );

        const scaleFactor =
          newZoom / prevZoom;

        setImgPosition((prev) => {
          const centerX =
            prev.x +
            imgWidth / 2;

          const centerY =
            prev.y +
            imgHeight / 2;

          const nextX =
            prev.x -
            (mouseX - centerX) *
              (scaleFactor - 1) *
              0.5;

          const nextY =
            prev.y -
            (mouseY - centerY) *
              (scaleFactor - 1) *
              0.5;

          return clampPosition(
            nextX,
            nextY,
            newZoom
          );
        });

        return newZoom;
      });
    }

    el.addEventListener(
      "wheel",
      handleWheel,
      {
        passive: false,
      }
    );

    return () => {
      el.removeEventListener(
        "wheel",
        handleWheel
      );
    };
  }, [imgZoom, baseSize]);

  function onImageLoad() {
    const container =
      containerRef.current;

    const img =
      imgRef.current;

    if (!container || !img) {
      return;
    }

    img.style.transform = "none";

    const containerRect =
      container.getBoundingClientRect();

    const imgRect =
      img.getBoundingClientRect();

    const initialZoom = Math.max(
      containerRect.width / imgRect.width,
      containerRect.height / imgRect.height
    );

    setBaseSize({
      width: imgRect.width,
      height: imgRect.height,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight,
    });

    setImgZoom(initialZoom);

    setImgPosition({
      x:
        (containerRect.width -
          imgRect.width) /
        2,

      y:
        (containerRect.height -
          imgRect.height) /
        2,
    });
  }

  async function handleSave() {
    setIsSaving(true);

    try {
      const img =
        imgRef.current;
      const canvas =
        previewCanvasRef.current;
      const ctx =
        canvas.getContext("2d");
      const container =
        containerRef.current.getBoundingClientRect();

      const baseWidth =
        baseSize.width;
      const baseHeight =
        baseSize.height;
      const scaledWidth =
        baseWidth * imgZoom;
      const scaledHeight =
        baseHeight * imgZoom;
      const offsetX =
        imgPosition.x -
        (scaledWidth -
          baseWidth) /
          2;
      const offsetY =
        imgPosition.y -
        (scaledHeight -
          baseHeight) /
          2;
      const visibleLeft =
        -offsetX / imgZoom;
      const visibleTop =
        -offsetY / imgZoom;
      const scaleX =
        baseSize.naturalWidth /
        baseWidth;
      const scaleY =
        baseSize.naturalHeight /
        baseHeight;
      const cropWidth =
        container.width /
        imgZoom;
      const cropHeight =
        container.height /
        imgZoom;
      const sx =
        visibleLeft * scaleX;
      const sy =
        visibleTop * scaleY;
      const sw =
        cropWidth * scaleX;
      const sh =
        cropHeight * scaleY;
      canvas.width =
        Math.max(
          Math.round(cropWidth),
          500
        );

      canvas.height =
        Math.max(
          Math.round(cropHeight),
          500
        );

      ctx.clearRect(
        0,
        0,
        canvas.width,
        canvas.height
      );

      ctx.drawImage(
        img,
        sx,
        sy,
        sw,
        sh,
        0,
        0,
        canvas.width,
        canvas.height
      );

      const blob =
        await new Promise(
          (resolve, reject) => {
            canvas.toBlob(
              (b) => {
                if (!b) {
                  reject(
                    new Error(
                      "Blob creation failed"
                    )
                  );
                } else {
                  resolve(b);
                }
              },
              "image/png",
              0.95
            );
          }
        );

      await onSave(blob);
    } catch (err) {
      console.error(
        "Save failed:",
        err
      );
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div
      className="resize-img-mode"
      onClick={(e) =>
        e.stopPropagation()
      }
    >
      <div
        ref={containerRef}
        className="resize-img-stack"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
      >
        {cropUrl && (
          <img
            ref={imgRef}
            alt='no-img'
            src={cropUrl}
            onLoad={onImageLoad}
            className="resize-image"
            crossOrigin="anonymous"
            draggable={false}
            style={{
              transform: `
                  translate(${imgPosition.x}px, ${imgPosition.y}px)
                  scale(${imgZoom})
                `,
              transformOrigin:
                "center center",
            }}
          />
        )}
        <div className="mask" />
        {isSaving && (
          <div className="loading-overlay">
            <div className="spinner" />
            <p>Saving</p>
          </div>
        )}
      </div>
      <div className="resize-options">
        <button
          onClick={onCancel}
          disabled={isSaving}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          disabled={isSaving}
        >
          Crop
        </button>
      </div>
      <canvas
        ref={previewCanvasRef}
        style={{
          display: "none",
        }}
      />
    </div>
  );
}

function UploadProfilePic({setIsUploading, loginID, person, currentPic, onClose}) {
  const queryClient = useQueryClient();
  const fileInputRef = useRef(null);
  const openedRef = useRef(false);

  const uploadMedia = useUploadMedia();
  const updatePerson = useUpdatePerson();
  const addImgDesc = useAddImgDesc();
  const updateImgDesc = useUpdateImgDesc();

  const [step, setStep] = useState("pick");
  // pick | crop | details | uploading

  const [file, setFile] = useState(null);
  const [croppedBlob, setCroppedBlob] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  const [selectedDesc, setSelectedDesc] = useState({});
  const [isLeapYear, setIsLeapYear] = useState(false);
  const [dayArray, setDayArray] = useState([]);

  const deleteMedia = useDeleteMedia();
  const deleteImgDesc = useDeleteImgDesc();
  
  const {data: oldDesc, isLoading: loading, error} = useImgDesc(currentPic ?? "S_logo_PNG.png"); 

  const MONTHS = [
    "", "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const YEARS = [
    "", 
    ...Array.from(
      { length: new Date().getFullYear() - 1900 + 1 },
      (_, i) => new Date().getFullYear() - i
    ),
  ];

  const keyVisuals = {
    "date": {
      "month": "Month",
      "day": "Day",
      "year": "Year"
    },
    "subtext": "Image Description"
  }

  useEffect(() => {
    if (openedRef.current) return;

    console.log("bruh")

    openedRef.current = true;

    requestAnimationFrame(() => {
      fileInputRef.current?.click();
    });
  }, []);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  function handleFileSelect(e) {
    const selected =
      e.target.files?.[0];

    e.target.value = "";

    if (!selected) {
      setIsUploading(false);
      return;
    }

    setFile(selected);
    setSelectedDesc({
      people: [loginID],
      profilePic: true,
      date: {
        month: "",
        day: "",
        year: ""
      }
    })
    setStep("crop");
  }

  async function handleFinalUpload() {
    if (!croppedBlob) return;

    try {
      setUploading(true);
      setStep("uploading");

      const finalFile = new File(
        [croppedBlob],
        `profile-${getLocalDateString()}.png`,
        {
          type: "image/png",
        }
      );

      console.log("4")
      const res =
        await uploadMedia.mutateAsync(
          finalFile
        );

      await updatePerson.mutateAsync({
        id: loginID,
        data: {
          ...person,
          profile_pic: res.media_id
        },
      });
      
      const cleanedDesc = cleanDesc(selectedDesc)
      const today = getLocalDateStringISO();

      console.log("3")
      await addImgDesc.mutateAsync({
        id: res.media_id,
        data: {
          img_name: finalFile.name,
          saved_date: today,
          uploaded_by: loginID,
          ...cleanedDesc,
        }
      })

      if (currentPic && oldDesc["cropped"]) {
        console.log("1")
        await deleteMedia.mutateAsync(currentPic);
      } else if (currentPic) {
        console.log("2")
        const {profilePic, ...changedData} = oldDesc;
        await updateImgDesc.mutateAsync({
          id:currentPic,
          data:changedData
        }); 
      }
      if (currentPic && oldDesc["cropped"]) {
        await deleteImgDesc.mutateAsync(currentPic);
      }
      
      // queryClient.invalidateQueries({queryKey: ['people', loginID]})
      queryClient.setQueryData(["people", loginID], (old) => ({
        ...old,
        profile_pic: res.media_id,
      }));

      setIsUploading(false);

    } catch (err) {
      console.error(
        "Upload failed:",
        err
      );

      setStep("details");

    } finally {
      setUploading(false);
      onClose();
    }
  }

  function cleanDesc(data) {
    const cleaned = {};

    for (const [key, value] of Object.entries(data)) {
      if (value === "" || value === null || value === undefined || value === false) continue;
      if (Array.isArray(value)) {
        if (value.length === 0) continue;

        const cleanedArray = value
          .map(item => (typeof item === 'object' ? cleanDesc(item) : item))
          .filter(item =>
            typeof item === 'object'
              ? Object.keys(item).length > 0
              : item !== ""
          );
        if (cleanedArray.length === 0) continue;
        cleaned[key] = cleanedArray;
        continue
      }
      if (typeof value === "object") {
        if (Object.values(value).includes(0)) continue;
        const cleanedObj = cleanDesc(value);
        if (Object.keys(cleanedObj).length === 0) continue;
        cleaned[key] = cleanedObj;
        continue;
      } 
      if (key === "profilePic") {
        if (value) {
          cleaned[key] = `${data["people"][0]}_profile_pic`;
        }
        continue;
      }
      cleaned[key] = value;
    } 
    return cleaned;
  }

  function updateField(key, value) {
    setSelectedDesc(prev => ({
      ...prev,
      [key]: value
    }));
  }

  const getObject = (key, subKeys) => {
    const obj = selectedDesc[key] || {};
    const normalized = {};
    subKeys.forEach(subKey => {
      normalized[subKey] = obj?.[subKey] ?? "";
    });
    return normalized;
  };

  const updateObjectItem = (key, subKey, value) => {
    setSelectedDesc(prev => {
      const obj = prev[key] || {};

      const newDesc = {
        ...obj,
        [subKey]: value
      }

      if (subKey === "year") {
        if (value % 4 === 0) {
          setIsLeapYear(true);
        }
      }

      if (subKey === "month") {
        if ([1,3,5,7,8,10,12].includes(value)) {
          setDayArray([
            "", 
            ...Array.from({length: 31}, (_, i) => i+1),
          ]);
        } else if ([4,6,9,11].includes(value)) {
          setDayArray([
            "", 
            ...Array.from({length: 30}, (_, i) => i+1),
          ]);
        } else if (value === 2 && isLeapYear) {
          setDayArray([
            "", 
            ...Array.from({length: 29}, (_, i) => i+1),
          ]);
        } else if (value === 2) {
          setDayArray([
            "", 
            ...Array.from({length: 28}, (_, i) => i+1),
          ]);
        } else {
          setDayArray([]);
          updateObjectItem("date", "day", 0)
        }
      }

      return {
        ...prev,
        [key]: newDesc
      };
    })
  };

  const renderField = (key) => {
    if (key === "date") {
      let subKeys = [];
      let keyName = "";
      if (key === "date") {
        subKeys = ["month", "day", "year"];
        keyName = "Date Taken";
      }
      const obj = getObject(key, subKeys);
      return(
        <div className={`edit-input object-input date-input`} key={key}>
          <label>{keyName}:</label>
          {subKeys.map((subKey) => (
            <div className="edit-input object-element" key={subKey}>
              <div className="sub-label">{keyVisuals[key][subKey]}</div>
              {subKey === "month" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box`}
                  value={obj[subKey]}
                  onChange={(e) => {updateObjectItem(key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {MONTHS.map((month, index) => (
                    <option key={month} value={index}>
                      {month}
                    </option>
                  ))}
                </select>   
              }
              {subKey === "day" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box ${dayArray.length ? "" : "day-disabled"}`}
                  value={obj[subKey]}
                  disabled={dayArray.length === 0}
                  onChange={(e) => {updateObjectItem(key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {dayArray.map(day => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </select>   
              } 
              {subKey === "year" && 
                <select
                  className={`sub-input date-subinput ${subKey}-box`}
                  value={obj[subKey]}
                  onChange={(e) => {updateObjectItem(key, subKey, e.target.value ===""?"":Number(e.target.value))}}
                >
                  {YEARS.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>   
              } 
            </div>
          ))}    
        </div>
      )
    } else if (key === "subtext") {
      return(
        <div className="subtext-input">
          <label className={`single-label`}>{keyVisuals[key]}:</label>
          <textarea
            value={selectedDesc[key] ?? ""}
            rows={1}
            onInput={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
            onChange={(e) => updateField(key, e.target.value)}
            autoComplete='batman'
            className={`${key}-box`}
            placeholder="What's in this photo?"
          />
        </div>
      )
    }
  }

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!file) return;
      
      event.preventDefault();
      event.returnValue =
        "Are you sure you want to leave this page? Any data will not be saved.";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [file]);

  usePrompt(
    "Are you sure you want to leave this page? New profile picture will not be saved.",
    file
  );


  useEffect(() => {
    console.log("UploadProfilePic mounted");

    return () => console.log("UploadProfilePic unmounted");
  }, []);


  if (loading) return "";
  if (error) return "";

  return (
    <div className="upload-img-mode">
      {step === "pick" && (
        <div className="loading-picker">
          Select an image...
        </div>
      )}
      {step === "crop" && file && (
        <ResizeProfilePic
          imageSrc={URL.createObjectURL(file)}
          onCancel={() => setIsUploading(false)}
          onSave={(blob) => {
            if (previewUrl) {
              URL.revokeObjectURL(
                previewUrl
              );
            }
            const url =
              URL.createObjectURL(
                blob
              );
            setCroppedBlob(blob);
            setPreviewUrl(url);
            setStep("details");
          }}
        />
      )}
      {step === "details" && (
        <div className="profile-upload-editor">
          <div className="preview-box">
            <img
              src={previewUrl}
              alt=""
              className='preview-image'
            />
          </div>
          <div className="field-group">
            {renderField("date")}
            {renderField("subtext")}
          </div>
          <div className="button-row">
            <button onClick={() => setStep("crop")}>
              Re-Crop
            </button>
            <button onClick={() => setIsUploading(false)}>
              Cancel
            </button>
            <button disabled={uploading} onClick={handleFinalUpload}>
              Upload
            </button>
          </div>
        </div>
      )}
      {step === "uploading" && (
        // <div className="loading-picker">
        //   Uploading...
        // </div>
        <Loading word='Uploading' />
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={handleFileSelect}
      />
    </div>
  );
}